import React, { useState, useContext, useEffect, useRef } from "react";
import { Icon, Label, Select, SelectOption, TabRoot, TabList, TabTrigger, TabContent, Button } from "@pmi/nyx-design-system";
import { SidebarContext } from "../../context/sidebarcontext";
import { FiltersContext } from "../../context/filterscontext";
import { MapviewContext } from "../../context/mapviewcontext";
import { ApiContext } from "../../context/apicontext";

// Right sidebar code
function RegionDataBar({ isCloseSidebar, selectedPlace, loadRegion, loadInnerTerritory }) {
  const { setBreadcrumbData, currentPolygonRef } = useContext(SidebarContext);
  const {benchmarkData, rightdemographicsData,districtData} = useContext(ApiContext);
  const [selectedValue, setSelectedValue] = useState();
  const { setShowFilters, setHandleData } = useContext(FiltersContext);
  const {selectedRegion, setSelectedTerritory, setSelectedRegion, selectedTerritory} = useContext(MapviewContext);

  useEffect(() => {
  }, [selectedPlace, selectedTerritory, selectedRegion]);

  const handleOptions = (value) => {
    const selectedOption = benchmarkData?.rightOptions?.find(option => option.value === value);
    if (selectedOption) {
      setSelectedValue(selectedOption.text);
    }
  };

  // Set first option as default
  useEffect(() => {
    if (benchmarkData?.rightOptions?.length > 0) {
      setSelectedValue(benchmarkData.rightOptions[0].text);
    }
  }, [benchmarkData]);

  const openTerritoryMap = () => {
    if (!currentPolygonRef.current) {
      currentPolygonRef.current = selectedPlace;
    }
    if (!!selectedRegion) {
      setShowFilters(true);
      loadInnerTerritory({ selectedTerritory: selectedPlace, center: [16.6180, 49.1918], zoom: 14 })
      setSelectedTerritory(selectedPlace)
    } else {
      setShowFilters(false);
      setSelectedRegion(selectedPlace);
      loadRegion({ selectedRegion: selectedPlace, polygonData: districtData, center: [17.0677, 49.1000], zoom: 7.8 })
    }
    setBreadcrumbData(currentPolygonRef.current);
    isCloseSidebar(false)
    setHandleData(true);
  }

  return (
    <>
      <div className="right-panel h-100">
        <div className="right-header" >
          <div className="d-flex w-100 justify-content-between">
            <div>
              <Label size="small" className="text-transform-none small lh-1">{selectedTerritory ? selectedTerritory : 'Czech republic'}</Label>
              <Label className="label fs-5 lh-base">{selectedPlace}</Label>
            </div>
            <Icon color="black" role="button" data-testid="icon-test" name="close" size="large" className="close-icon" onClick={() => { isCloseSidebar(false) }} />
          </div>
          {/* Open Button */}
          <Button color="primary" endicon="chevron-right" size="large" style={{ width: '100%', borderRadius: '30px', justifyContent: 'center' }} onClick={openTerritoryMap}>
            Open territory map  <Icon color="white" role="button" data-testid="icon-test" name="chevron-right" size="large" />
          </Button>
        </div>

        <div className="right-panel-inner">
          <div className="benchmark-column p-4 pe-3 pb-0 mb-2">
            <div className="d-flex alim-align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="d-flex bg-lightgray p-1 rounded-3 me-1">
                  <Icon color="dark" size='small' data-testid="icon-test" name="clipboard-list" />
                </div>
                <h6 className="small fw-bold">Benchmark column</h6>
              </div>
              <Select className="dropdown-box" starticon="download" endicon="chevron-down" placeholder={selectedValue} size="small" onChange={(value) => handleOptions(value)} >
                {benchmarkData.rightOptions.map((option, index) => (
                  <SelectOption key={index} value={option.value}>
                    {option.text}
                  </SelectOption>
                ))}
              </Select>
            </div>
            <div className="divider-gray mt-4"></div>
          </div>

          {/* Demographics Data */}
          <div className="accordion ps-4 pe-3" id="demographicsAccordion1">
            <div className="accordion-item">
              <h2 className="accordion-header py-2" id="headingRight">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse1"
                  aria-expanded="true"
                  aria-controls="collapse"
                >
                  Demographics
                </button>
              </h2>
              <div
                id="collapse1"
                className="accordion-collapse collapse show"
                aria-labelledby="headingRight"
                data-bs-parent="#demographicsAccordion1"
              >
                <div className="accordion-body">
                  <div className="demographics-data small px-2">
                    <Label className="d-flex align-items-center text-transform-none fw-bold small">Indicator</Label>
                    <Label className="text-transform-none fw-bold small">Actual</Label>
                    <Label className="d-flex align-items-center fw-bold small"><div className="d-flex bg-lightgray p-1 rounded-3 me-1"><Icon color="dark" data-testid="icon-test" name="clipboard-list" size="small" /></div>Benchmark</Label>
                  </div>
                  {rightdemographicsData.Demographics.map((row, index) => (
                    <div key={index} className="tab-data px-2">
                      <div className="d-flex align-items-center">
                        <Label className="text-transform-none">{row.indicator}</Label>
                      </div>
                      <span className="text-transform-none">{row.actual}</span>
                      <span className={"text-transform-none"} style={{ color: row.benchmark === 'N/A' || row.benchmark === 'No data' ? 'gray' : 'black' }}> {row.benchmark} </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 pe-3">

            {/* Performance Data */}
            <TabRoot defaultValue="tab1">
              <div className="tab-list">
                <TabList>
                  <TabTrigger badgeColor="primary" badgeValue={0} value="tab1">
                    Performance
                  </TabTrigger>
                  <TabTrigger value="tab2">
                    Density & coverage
                  </TabTrigger>
                </TabList>
              </div>
              <TabContent value="tab1">

                {/* CONSUMABLES data  */}
                <Label size="small" color="gray" className="text-transform-none text-muted py-1"><Icon color="dark" className="m-1 mb-2" data-testid="icon-test" name="alert-circle" size="small" />Monthly average</Label>
                <div className="py-3 fw-bold">CONSUMABLES</div>
                <div className="demographics-data">
                  <Label className="text-transform-none fw-bold small">Indicator</Label>
                  <Label className="text-transform-none fw-bold small">Actual</Label>
                  <Label className="d-flex align-items-center fw-bold small"><div className="d-flex bg-lightgray p-1 rounded-3 me-1"><Icon color="dark" data-testid="icon-test" name="clipboard-list" size="small" /></div>Benchmark</Label>
                </div>
                {rightdemographicsData.Consumables.map((row, index) => (
                  <>
                    <div key={index} className="tab-data">
                      <Label className="text-transform-none">{row.indicator}</Label>
                      <span>{row.actual}</span>
                      <span style={{ color: row.benchmark === 'N/A' || row.benchmark === 'No data' ? 'gray' : 'black' }}> {row.benchmark}{row.benchmark === 'N/A' || row.benchmark === 'No data' ? '' : '%'}</span>
                    </div>
                    {/* {row?.subItems?.map((item, index) => (
                      <div key={index} className="tab-data px-3">
                        <Label className="text-transform-none">{item.indicator}</Label>
                        <span style={{ color: item.benchmark === 'N/A' || item.benchmark === 'No data' ? 'gray' : 'black' }}>{item.actual}</span>
                        <span style={{ color: item.benchmark === 'N/A' || item.benchmark === 'No data' ? 'gray' : 'black' }}>{item.benchmark}</span>
                      </div>
                    ))} */}
                  </>
                ))}

                {/* KITS  data*/}
                <div className="py-3 fw-bold">KITS</div>
                <div className="demographics-data">
                  <Label className="text-transform-none fw-bold small">Indicator</Label>
                  <Label className="text-transform-none fw-bold small">Actual</Label>
                  <Label className="d-flex align-items-center fw-bold small"><div className="d-flex bg-lightgray p-1 rounded-3 me-1"><Icon color="dark" data-testid="icon-test" name="clipboard-list" size="small" /></div>Benchmark</Label>
                </div>
                {rightdemographicsData.Kits.map((row, index) => (
                  <>
                    <div key={index} className="tab-data">
                      <Label className="text-transform-none">{row.indicator}</Label>
                      <span style={{ color: row.actual === 'N/A' || row.actual === 'No data' ? 'gray' : 'black' }}>{row.actual}</span>
                      <span style={{ color: row.benchmark === 'N/A' || row.benchmark === 'No data' ? 'gray' : 'black' }}>{row.benchmark}{row.benchmark === 'N/A' || row.benchmark === 'No data' ? '' : '%'}</span>
                    </div>
                  </>
                ))}
              </TabContent>
              <TabContent value="tab2">
                No data found
              </TabContent>
            </TabRoot>
          </div>
        </div>
      </div>
    </>
  )
}
export default RegionDataBar;